import { PatchReleaseNoteByodRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdateReleaseNoteByodRequest';
import { createReleaseNoteByodHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/ReleaseNoteByodHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateReleaseNoteByod = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createReleaseNoteByodHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: PatchReleaseNoteByodRequest }) => {
      if (!repository) throw new Error('Repository not initialized');
      return await repository.update(id, data);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['release-notes-byod'] });
      queryClient.invalidateQueries({ queryKey: ['release-note-byod', variables.id] });
    },
  });
};
